import styled from "styled-components";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";

export const StyledInputWrapper = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
`;

export const StyledIncrement = styled.div`
    background: ${colorsPalettes.bluegrey[100]};
    color: ${colorsPalettes.blue[400]};
    cursor: pointer;
    display: flex;
    ${setFontVariant("body1")};
    width: 41px;
    align-items: center;
    justify-content: center;
    box-shadow: -1px 0px 2px rgba(196, 196, 196, 0.25);
`;

export const StyledInput = styled.input`
    background: ${colorsPalettes.bluegrey[100]} !important;
    display: flex;
    width: 30px;
    text-align: center;
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
    ${setFontVariant("body1", colorsPalettes.carbon[400])};

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &[type="number"] {
        -moz-appearance: textfield;
    }
`;

export const StyledDecrement = styled.div`
    display: flex;
    background: ${colorsPalettes.bluegrey[100]};
    color: ${colorsPalettes.blue[400]};
    cursor: pointer;
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
    width: 41px;
    align-items: center;
    justify-content: center;
    box-shadow: 2px 0px 2px rgb(196 196 196 / 25%);
`;
